import { ASSET_TYPE, type AssetType } from 'src/data/asset/const';

export type ImageOverlayProps = {
  [key in ImageOverlayTextField]?: string;
};

export type ImageOverlayPropsWithAttributes = {
  [key in ImageOverlayTextField]?: { text?: string; assetType?: string };
};

export const IMAGE_OVERLAY_TEXT_PREFIX = 'Overlay text -';

export const IMAGE_OVERLAY_TEXT_FIELD = {
  headline: 'headline',
  subHeadline: 'subHeadline',
  cta: 'callToAction',
} as const;
export type ImageOverlayTextField =
  (typeof IMAGE_OVERLAY_TEXT_FIELD)[keyof typeof IMAGE_OVERLAY_TEXT_FIELD];

const IMAGE_OVERLAY_TEXT_FIELD_PROPS = {
  [IMAGE_OVERLAY_TEXT_FIELD.headline]: {
    title: 'Headline',
    assetType: ASSET_TYPE.landingHeadline,
  },
  [IMAGE_OVERLAY_TEXT_FIELD.subHeadline]: {
    title: 'Sub-headline',
    assetType: ASSET_TYPE.landingBuilderSubHeadline,
  },
  [IMAGE_OVERLAY_TEXT_FIELD.cta]: {
    title: 'Call to action',
    assetType: ASSET_TYPE.landingCTA,
  },
};

export const getImageOverlayTextFieldTitle = (
  type: ImageOverlayTextField,
  options?: { displayPrefix: boolean }
): string => {
  if (options?.displayPrefix) {
    return `${IMAGE_OVERLAY_TEXT_PREFIX} ${IMAGE_OVERLAY_TEXT_FIELD_PROPS[type]?.title || type}`;
  }
  return IMAGE_OVERLAY_TEXT_FIELD_PROPS[type]?.title || type;
};

export const getImageOverlayTextFieldAssetType = (type: ImageOverlayTextField): AssetType =>
  IMAGE_OVERLAY_TEXT_FIELD_PROPS[type]?.assetType;

export const initImageOverlayProps = (): ImageOverlayProps =>
  Object.values(IMAGE_OVERLAY_TEXT_FIELD).reduce((acc, field) => {
    acc[field] = '';
    return acc;
  }, {} as ImageOverlayProps);

export const getImageOverlayPropsValues = (overlayProps?: ImageOverlayProps): string[] => {
  if (!overlayProps) {
    return [];
  }

  return Object.values(IMAGE_OVERLAY_TEXT_FIELD)
    .map((field) => overlayProps?.[field] || '')
    .filter(Boolean);
};

export const formatImageOverlayProps = (
  overlayProps: ImageOverlayProps,
  options?: { separator: string }
): string => {
  const result: string[] = [];
  Object.values(IMAGE_OVERLAY_TEXT_FIELD).forEach((type) => {
    if (overlayProps[type]) {
      result.push(`${getImageOverlayTextFieldTitle(type)}: ${overlayProps[type]}`);
    }
  });
  return result.join(options?.separator || ', ');
};

export const countPresentImageOverlayTexts = (overlayProps?: ImageOverlayProps): number =>
  getImageOverlayPropsValues(overlayProps).length;

export const hasImageOverlayTexts = (overlayProps?: ImageOverlayProps): boolean =>
  countPresentImageOverlayTexts(overlayProps) > 0;
